import {Heading} from "@/components/ui/heading";
import {Button} from "@/components/ui/button";
import React from "react";
import {useNavigate} from "react-router-dom";
import Paths from "../../../constants/Paths";


const Slide3 = () => {
    const navigate = useNavigate();

    return (
        <div className="slide-3">
            <div className="generic-container">
                <Heading level={1} className='hero-title'>
                    We make<br/>
                    trading easier!<br/>
                </Heading>
                <Heading level={2} className='hero-subtitle'>
                    Explore it with us<br/>
                    <span>through the AI Assistant</span><br/>
                </Heading>
                <Button onClick={() => navigate(Paths.VIRTUAL_ASSISTANT)} className="big-button white-variant">Our <strong>AI</strong> Assistant</Button>
            </div>
        </div>
    )
}

export default Slide3;